module.exports = __webpack_public_path__ + "img/netProfitGreen.49466664.png";